import _ from "lodash";
import { useState } from "react";
import { ethers } from "ethers";
import ERC20ABI from "../abi/ERC20ABI.json";
import { useAtom } from "jotai";
import { tokenContractAddress } from "../stateManagement/tokenAddressAtom";

export const useAddMultipleHolders = () => {
  const [message, setMessage] = useState("");
  const [waitAddMultipleHolders, setWaitAddMultipleHolders] = useState(false);
  const tokenAddress = localStorage.getItem("tokenContractAddress");

  const callAddMultipleHolders = async (
    signer: ethers.ContractRunner | null | undefined,
    holders: string[],
    amount: any[],
    customerId: string[],
  ) => {
    try {
      setWaitAddMultipleHolders(true);

      const callAbi = new ethers.Contract(
        tokenAddress || "",
        ERC20ABI.abi,
        signer
      );

      const tx = await callAbi.addMultipleHolders(holders, amount, customerId);

      setWaitAddMultipleHolders(false);
      return { err: "", tx: tx };
    } catch (err: any) {
      const errs = _.get(err, "error.message");
      const msgs = _.get("", errs);
      if (err.code === "ACTION_REJECTED") {
        setWaitAddMultipleHolders(false);
        setMessage("User rejected transaction");
        return { err: "User rejected transaction", tx: "" };
      } else {
        if (msgs === undefined) {
          setWaitAddMultipleHolders(false);
          setMessage((/missing revert data/).test(err.message.split("(")[0]) ? "Invalid data, please ensure the holders in the file are new." : err.message.split("(")[0] || "");
          return { err: (/missing revert data/).test(err.message.split("(")[0]) ? "Invalid data, please ensure the holders in the file are new." : err.message.split("(")[0] || "", tx: "" };
        } else {
          setWaitAddMultipleHolders(false);
          setMessage(msgs.msg);
          return { err: msgs.msg, tx: "" };
        }
      }
    }
  };

  return {
    onAddMultipleHolders: callAddMultipleHolders,
    waitAddMultipleHolders: waitAddMultipleHolders,
    messageError: message,
  };
};
